import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */

  getStoreAdList(id, params) {
    return backofficeService.Api().get(`api/commercial/clickImages/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },


  getAllListAds(params) {
    return backofficeService.Api().get('api/adimage', { params })
      .then(response => response.data.data)
      .catch((error) => { throw error })
  },
  /**
   * Get category by id
   * @param {*} params Query Options
   */
  getById(id, params) {
    return backofficeService.Api().get(`api/clickImages/${id}`, { params })
    .then(response => response.data)
      .catch((error) => { throw error })
  },

  commercialCreate(data) {
    return backofficeService.Api().post('api/commercial/clickImages', data)
    .then(response => response.data)
    .catch((error) => { throw error })
  },

  resetCommercial(data) {
    return backofficeService.Api().post('api/commercial/reset', data)
    .then(response => response.data)
    .catch((error) => { throw error })
  },

  create(data) {
    return backofficeService.Api().post('api/clickImages', {AdImage: data})
    .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`api/clickImages/${id}`,data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete category
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`api/clickImages/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
